module.exports = __webpack_public_path__ + "static/621_Kirkstone_Ct-fadda8954b05b87e02c563ab617646e8.webp";